import { Breakpoints } from '@/hooks/useBreakpoint';
import styled, { css } from 'styled-components';

export const Container = styled.div<{ $breakpoint: Breakpoints }>`
  display: flex;
  flex-direction: column;
  flex: 1;
  ${({ theme, $breakpoint }) => {
    return css`
      gap: ${theme.spacing[5]}px;
      background-color: ${$breakpoint === 'desktop'
        ? theme.panel.solid
        : 'transparent'};
      border-radius: ${theme.radius[4]}px;
    `;
  }}

  ${({ theme, $breakpoint }) => {
    if ($breakpoint === 'mobile') return '';
    return css`
      padding: ${theme.spacing[5]}px;
    `;
  }}
`;

export const ContainerTextos = styled.div<{ $breakpoint: Breakpoints }>`
  display: flex;
  flex-direction: column;
`;

export const ContainerListagens = styled.div<{ $breakpoint: Breakpoints }>`
  display: flex;
  flex: 1;

  ${({ theme, $breakpoint }) => {
    if ($breakpoint === 'mobile')
      return css`
        flex-direction: column;
        gap: ${theme.spacing[5]}px;
      `;
    return css`
      flex-direction: row;
      gap: ${theme.spacing[7]}px;
    `;
  }};
`;
